function pharmacyBase() {
  let stateCheck = setInterval(() => { if (document. readyState === 'complete') {
    clearInterval(stateCheck);
  const pharmacyPoints = document.querySelector('.pharmacy-points');

  if (pharmacyPoints) {
    const areas = pharmacyPoints.querySelectorAll('.pharmacy-points__area');

    const collapseAll = () => {
      areas.forEach(area => area.classList.remove('active'));
      const arrows = document.querySelectorAll('.pharmacy-points__areas .less');
      arrows?.forEach((arrow) => {
        arrow.classList.remove('less');
      });
    }

    const mores = document.querySelectorAll('.pharmacy-points__show-more');
    mores?.forEach((more)=> {
      more.addEventListener('click', (e) => {
        e.stopPropagation();
        showMore(more);
      });
    });

    const showMore = (more) => {
      const places = more.parentNode.querySelectorAll('.pharmacy-points__place')
      if (more.classList.contains('less')) {
        more.classList.remove('less');
        if (places && places.length) {
          Array.from(places).slice(4).forEach(el => {
            el.classList.add('hidden');
          })
        }
      } else {
        more.classList.add('less');
        if (places && places.length) {
          places.forEach(el => {
            el.classList.remove('hidden');
          });
        }
      }
    }

    const rollout = (area) => {
      area.classList.add('active');
      let more = area.querySelector('.pharmacy-points__show-more');
      let places = area.querySelectorAll('.pharmacy-points__place');
      places.forEach(el => {
        el.classList.remove('hidden');
      })
      more.classList.remove('hidden');
      more.classList.remove('less');
      more.classList.add('less');
    }

    areas.forEach(area => {
      const showmore = area.querySelector('.showmore');
      showmore.addEventListener('click', e => {
        e.target.setAttribute('aria-expanded', true)
        collapseAll();
        rollout(area);
      });

      showmore.addEventListener('keydown', e => {
        if (e.keyCode == 13) { //enter
          e.target.setAttribute('aria-expanded', true)
          collapseAll();
          rollout(area);
        }
      });
    });

    let chooseButtons = document.querySelectorAll('.pharmacy-point__choosebutton');
    chooseButtons.forEach((chooseButton)=>{
      chooseButton.addEventListener('click', (e) => {
        e.stopPropagation();
        buyAtPharmacy(chooseButton);
      });
    });

    const rolloutVoivodesMenu = () => {
      const voivodesMobile = document.querySelector('.voivodes-mobile');
      const hiddenfor2 = document.querySelector('.hidden-for2');
      hiddenfor2?.classList.remove('hidden-for2');
      btnOpenVoivodesNonMobile?.classList.add('hidden');
    }

    const btnOpenVoivodesNonMobile = document.querySelector('.js-open-nonmobile-voivodes');
    btnOpenVoivodesNonMobile?.addEventListener('click', (e) => {
      e.stopPropagation();
      rolloutVoivodesMenu();
    });

    const btnOpenVoivodes = document.querySelector('.js-open-voivodes');
      btnOpenVoivodes.addEventListener('click', (e) => {
        e.stopPropagation();
        openVoivodesMenu();
    });

    const btnCloseVoivodes = document.querySelector('.js-close-voivodes');
    btnCloseVoivodes.addEventListener('click', (e) => {
      e.stopPropagation();
      closeVoivodesMenu();
    });

    const openVoivodesMenu = () => {
      const voivodesMobile = document.querySelector('.voivodes-mobile');
      const hiddenfor2 = document.querySelector('.hidden-for2');
      hiddenfor2?.classList.remove('hidden-for2');
      voivodesMobile.classList.add('menu-docked');
      voivodesMobile.classList.remove('pharmacy-points__sidebar');
      voivodesMobile.style.width = window.width;
      document.body.classList.add('stop-scroll');
    }

    const closeVoivodesMenu = () => {
      const voivodesMobile = document.querySelector('.voivodes-mobile');
      voivodesMobile.classList.remove('menu-docked');
      voivodesMobile.classList.add('pharmacy-points__sidebar');
      document.body.classList.remove('stop-scroll');
      collapseAll();
    }

    const buyAtPharmacy = (pharmacy) => {
      let postObj = {
        check_products: false,
        form_key: "MaEwRntJvms3p6TS",
        set_as_default: true,
        storelocator_id: pharmacy.dataset.pharmacy
      }

      let post = JSON.stringify(postObj);
      const url = "/storelocator/ajax/selectPharmacy";
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
      xhr.send(post);

      xhr.onload = function () {
        if (xhr.status === 200) {
            if (!Cookies.get('pharmacySelected')) {
                Cookies.set('pharmacySelected', '')
            }

            if (window?.GoogleAnalyticsUniversal?.prototype?.pharmacyEvent) {
                window.GoogleAnalyticsUniversal.prototype.pharmacyEvent('Pharmacy chosen', pharmacy.warehouse_id);
            }

            window.location.reload();
        }
      }
    }
  }
    const citiesMenuNodes = document.querySelectorAll('.pharmacies-cities p');
    if (citiesMenuNodes?.length) {
        if (citiesMenuNodes.length <= 60 ) {
          const greenBar = document.querySelector('.pharmacies-cities .footer__mega-links-rollout');
          greenBar?.classList.add('hidden');
        }
        const footerBox = document.querySelector('.pharmacies-cities .footer__mega-links-content');
        footerBox?.classList.add('columnmode' + Math.ceil(citiesMenuNodes.length/10));
    }

  } }, 100);
}

export { pharmacyBase }

